module.exports = __webpack_public_path__ + "static/media/os-version.ffa25a49.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/venueStatus/os-version.svg
// module id = 1564
// module chunks = 1